/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
class SubjectService {
  static getSiteNames(sites) {
    if (null == sites) {
      return;
    }
    return Object.keys(sites)
      .map((key) => {
        return sites[key].name;
      })
      .join(', ');
  }

  static getSiteTimezone(sites) {
    if (null == sites) {
      return [];
    }

    return Object.keys(sites).map((key) => {
      return sites[key].timezone;
    });
  }
}

export default SubjectService;
